import './InjuryStatistic.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useRef } from "react";

import { fetchInjury } from "../../slices/statisticSlice";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

const InjuryStatistic = ({params}) => {
    const dispatch = useDispatch();
    const injuryStatistic = useSelector((state) => state.statistic.injuryStatistic);
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const chartRef = useRef(null);

    useEffect(() => {
        dispatch(fetchInjury({token, params}));
    }, [dispatch, token, params]);

    useEffect(() => {
        setTimeout(() => {
            chartRef.current?.getEchartsInstance().resize();
        }, 100);
    }, [injuryStatistic]);

    const options = {
        title: {
            text: 'Типы травм по авариям',
            left: 'center'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            bottom: 0,
            textStyle: {
                fontSize: 10
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: injuryStatistic.map(item => item.emergency_type.alias || item.emergency_type.name),
            axisLabel: {
                rotate: 45,
                fontSize: 10
            }
        },
        yAxis: {
            type: 'value',
            name: 'Количество'
        },
        series: [
            {
                name: 'Легкие травмы',
                type: 'bar',
                data: injuryStatistic.map(item => item.minor_injury_total),
                itemStyle: { color: '#4CAF50' }
            },
            {
                name: 'Тяжелые травмы',
                type: 'bar',
                data: injuryStatistic.map(item => item.severe_injury_total),
                itemStyle: { color: '#FFC107' }
            },
            {
                name: 'Смертельные травмы',
                type: 'bar',
                data: injuryStatistic.map(item => item.fatal_injury_total),
                itemStyle: { color: '#F44336' }
            }
        ]
    };

    return (
        <Box className="injury_statistic">
            <ReactECharts ref={chartRef} option={options} style={{ width: '100%', height: '100%' }} />
        </Box>
    );
};

export default InjuryStatistic;